export const CATALOG_STORE_TYPES = {
  LOAD_CATALOG_STORE: "LOAD_CATALOG_STORE",
  GET_CATALOG_STORES: "GET_CATALOG_STORES",
  GET_CATALOG_STORE: "GET_CATALOG_STORE",
  UPDATE_CATALOG_STORE_DATA: "UPDATE_CATALOG_STORE_DATA",
  MERGE_CATALOG_STORE_ITEMS: "MERGE_CATALOG_STORE_ITEMS",
};

const initialState = {
  isLoading: false,
  items: [],
  total: 0,
  search: "",
  item: {
    name: "",
    isActive: true,
    geographicZone: "",
    updatedByApi: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CATALOG_STORE_TYPES.LOAD_CATALOG_STORE:
      return {
        ...state,
        isLoading: action.payload,
      };
    case CATALOG_STORE_TYPES.GET_CATALOG_STORES:
      return {
        ...state,
        items: action.payload.data,
        //item: initialState.item,
        total: action.payload.meta.total,
        isLoading: false,
      };

    case CATALOG_STORE_TYPES.GET_CATALOG_STORE:
      return {
        ...state,
        item: action.payload,
        // items: initialState.items,
        isLoading: false,
      };

    // LS-637 — complète items (sans le remplacer) avec des catalogues hors du
    // périmètre UserGroup de l'utilisateur, mais légitimement nécessaires pour
    // une demande de financement qu'il a déjà le droit de consulter (ex: TVA).
    case CATALOG_STORE_TYPES.MERGE_CATALOG_STORE_ITEMS: {
      const existingUuids = new Set(state.items.map((i) => i.uuid));
      const nouveaux = action.payload.filter((c) => !existingUuids.has(c.uuid));
      return nouveaux.length === 0
        ? state
        : { ...state, items: [...state.items, ...nouveaux] };
    }

    case CATALOG_STORE_TYPES.UPDATE_CATALOG_STORE_DATA:
      return {
        ...state,
        item: { ...state.item, [action.payload.key]: action.payload.value },
        isLoading: false,
      };

    default:
      return state;
  }
}
